import { SettingLayoutComponentId } from '@starsoft/common/models';
import { EarningsCard, EarningsCards } from './props';
import useAffiliatesVariant from '@/hooks/theme/variants/Affiliates/useAffiliatesVariant';

export default function getEarningsCards(
  earnings: EarningsCards,
): EarningsCard[] {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { version } = useAffiliatesVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.AffiliatesCardV1.toString():
      return earnings?.default;
    case SettingLayoutComponentId.AffiliatesCardV2.toString():
      return earnings?.kube;
    case SettingLayoutComponentId.AffiliatesCardV3.toString():
      return earnings?.ice;
    default:
      return earnings?.default;
  }
}
